import { useContext } from 'react'

import { OrganizationContext } from '@/context'

export const useOrganization = () => useContext(OrganizationContext)
